import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { InputContainer } from '../input-container/input-container.js';
import { canShowLabel } from '../input-container/input-container-utils.js';

function _TextField({ type = "text", value, label, placeholder, ariaLabel, onChange, onClear, error, helperText, disabled, startAdornment, endAdornment, requiredIndicator, rounded, size = "medium", className, clearAriaLabel, ...props }, ref) {
    return (jsx(Wrapper, { className: className, children: jsx(InputContainer, { ...(canShowLabel(size)
                ? {
                    label,
                    size,
                }
                : {
                    size,
                }), error: error, showClearButton: !!value, onClear: onClear, helperText: helperText, disabled: disabled, startAdornment: startAdornment, endAdornment: endAdornment, requiredIndicator: requiredIndicator, cursor: "text", rounded: rounded, clearAriaLabel: clearAriaLabel, children: jsx(StyledInput, { ref: ref, type: type, value: value, onChange: (e) => onChange?.(e.target.value, e), placeholder: placeholder, "aria-label": ariaLabel || label, "aria-errormessage": typeof error === "string" ? error : undefined, "aria-invalid": !!error, disabled: disabled, ...props }) }) }));
}
const TextField = forwardRef(_TextField);
/**
 * If the caller would extend the MTextField component, the modified/added CSS properties would be set to this wrapper
 * Oherwise, the styles would be applied to the input field
 */
const Wrapper = styled.div ``;
const StyledInput = styled.input `
  all: unset;
  width: 100%;
  text-align: left;
`;

export { TextField };
